import React from 'react';
import { HomeIcon as HeroHomeIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type HomeIconProps = Omit<IconProps, 'children'>;

export const HomeIcon: React.FC<HomeIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroHomeIcon />
        </Icon>
    );
};
